export default {"src":"/_next/static/media/ginger.49b908a4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};